/**
 * Consolidated plugin for third-party library integrations
 * This combines several simple library wrappers into a single plugin
 */

import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'

import VueSocialSharing from 'vue3-social-sharing'

import 'lite-youtube-embed'
import 'lite-youtube-embed/src/lite-yt-embed.css'

export default defineNuxtPlugin((nuxtApp) => {
    // Vue Final Modal
    const vfm = createVfm()
    nuxtApp.vueApp.use(vfm)

    // Social Sharing
    nuxtApp.vueApp.use(VueSocialSharing)

    // Lite YouTube is imported at module level (CSS side effects)
})
